<template>
    <LanguageForm :language="language" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import LanguageForm from './LanguageForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    LanguageForm
  },
  data() {
    return {
      color:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.language=await APIRequest.detail('languages',this.$route.params.id)
    this.loaded=true
  }
}
</script>
